import React from 'react';
import { LocationBiasContext, LocationBiasContextValue } from './location-bias-context';

export function useLocationBias(): LocationBiasContextValue {
    const locationBiasContextValue = React.useContext(LocationBiasContext);
    if (!locationBiasContextValue) {
        throw new Error('Unexpectedly could not find location bias context value.');
    }
    return locationBiasContextValue;
}
